import { render, staticRenderFns } from "./groupTree.vue?vue&type=template&id=56b62342&"
import script from "./groupTree.vue?vue&type=script&lang=js&"
export * from "./groupTree.vue?vue&type=script&lang=js&"
import style0 from "./groupTree.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports